const NEW_TAB_TARGET = "_blank";

const openNewTab = (url: string): void => {
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.target = NEW_TAB_TARGET;

  document.body.append(anchor);

  anchor.click();
  anchor.remove();
};

export default openNewTab;
